import React from 'react';
import Navbar from './Navbar';
import { Switch, Route } from "react-router-dom";
import Slide from './Slide';
import './Slide.css';
import './Navbar.css';
import Service from './Service';
import Contact from './Contact';
import Store from './Store';
import { NavLink } from 'react-router-dom';
import About from './Aboutus';

import Sliderhome2 from './Sliderhome2';
import Sliderhome3 from './Sliderhome3';

export default class Home extends React.Component {
  render() {
    return (

      <div>
        <div className="header">
          <div className="menu">
            <Navbar className="Navbar">

              <Switch className="switch">
                <Route exact path="/" component={Home}></Route>
                <Route exact path="/service" component={Service}></Route>
                <Route exact path="/store" component={Store}></Route>
                <Route path="/about" component={About}></Route>
                <Route path="/contact" component={Contact}></Route>

              </Switch>
            </Navbar>
          </div>
        </div>


        <div className="Services">
          <h1 >SERVICES</h1>
        </div>

        <div className="slider2"><Sliderhome2></Sliderhome2></div>
        <div className="Store">
          <h1 >OUR STORE</h1>

          <div className="provide">
            <div><img src="./images/accesories.png" alt="services"></img>
              <h3>CAR ACCESSORIES</h3></div>
            <div><img src="./images/ridinggear.jpg" alt="services">
            </img> <h3>RIDING GEAR</h3></div>
            <div><img src="./images/spareparts.jpg" alt="services">
            </img> <h3>SPARE PARTS</h3></div>
          </div>
        </div>

        <div className="slider3">
          <Sliderhome3 ></Sliderhome3>
        </div>
      </div>


    )
  }
}